import * as React from "react";

import { Textarea, type TextareaProps } from "@/components/ui/textarea";

interface AutoResizeTextareaProps extends TextareaProps {
  minHeight?: number;
}

export function AutoResizeTextarea({
  minHeight = 36,
  onInput,
  rows = 1,
  style,
  value,
  ...props
}: AutoResizeTextareaProps) {
  const textareaRef = React.useRef<HTMLTextAreaElement>(null);

  const resize = React.useCallback(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    textarea.style.height = "0px";
    textarea.style.height = `${Math.max(minHeight, textarea.scrollHeight)}px`;
  }, [minHeight]);

  React.useLayoutEffect(resize, [resize, value]);

  React.useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea || typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(resize);
    observer.observe(textarea);
    return () => observer.disconnect();
  }, [resize]);

  return (
    <Textarea
      {...props}
      ref={textareaRef}
      value={value}
      rows={rows}
      onInput={(event) => {
        resize();
        onInput?.(event);
      }}
      style={{ ...style, overflowY: "hidden" }}
    />
  );
}
